var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sound-wave-stage"},[(_vm.config.title)?_c('h1',{staticClass:"sound-wave-stage__title"},[_vm._v(_vm._s(_vm.config.title))]):_vm._e(),_c('div',{staticClass:"sound-wave-stage__meter",style:(_vm.meterStyle)},[_c('sound-wave-meter',{attrs:{"active":_vm.active,"config":_vm.config}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }